module.exports = __webpack_public_path__ + "img/umbrella-beach.04b1f114.svg";